// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterItemContent_root__3LEMJ","postText":"FilterItemContent_postText__37lIh"};